export const LISTVIEW = 'LISTVIEW'
export const DETAILVIEW = 'DETAILVIEW'
export const modes = [LISTVIEW, DETAILVIEW]

// State props
export const SORT_BY_STATE_PROP = 'sortBy'
export const ASC_STATE_PROP = 'asc'
